import React, { useRef, useState } from 'react';
import Icon, { iconNames } from '../components/Icon/icon';

const IconWrapper = () => {
  const _style: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    width: '130px',
    padding: '4px',
    border: '1px solid #ddd',
  };

  const [style, setStyle] = useState(_style);

  const changeColor = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setStyle({ ...style, color: 'red' });
    } else {
      setStyle({ ...style, color: '#0a0a0a' });
    }
  };

  return (
    <>
      <h1>
        📌 Icons <small>({iconNames.length}개)</small>
      </h1>
      <div className="option-container">
        <label>
          <input type="checkbox" onClick={changeColor} />
          {` 색상변경`}
        </label>
      </div>
      <div className="demo-wrapper">
        {iconNames.map((name, idx) => (
          <div key={idx} style={style}>
            <div style={{ width: '100%' }}>{idx + 1}</div>
            <Icon name={name} />
            {name}
          </div>
        ))}
      </div>
    </>
  );
};

export default IconWrapper;
